import { motion } from "framer-motion";
import { MapPin, Phone } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { useSite } from "../../lib/SiteContext";
import { Reveal, Overline } from "./Reveal";

const initials = (n) => n.split(" ").filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase();

export const Leadership = () => {
  const { t, lang } = useLang();
  const { settings: s } = useSite();
  const a = t.about;
  const name = s.ceo_name || "";
  const title = (lang === "hi" ? s.ceo_title_hi : s.ceo_title_en) || "";

  return (
    <section id="about" className="py-24 lg:py-32" data-testid="leadership-section">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8">
        <Reveal className="lg:col-span-6">
          <Overline>{a.over}</Overline>
          <h2 className="section-title mt-5">{a.title}</h2>
          <p className="mt-6 text-base leading-relaxed text-slate-300 md:text-lg">{a.body}</p>
          {s.address && (
            <p className="mt-8 flex items-start gap-3 text-sm text-slate-300" data-testid="about-address">
              <MapPin size={18} className="mt-0.5 shrink-0 text-saffron" />
              <span><span className="block text-xs uppercase tracking-wider text-slate-400">{a.hq}</span>{s.address}</span>
            </p>
          )}
        </Reveal>
        {name && (
          <Reveal delay={0.15} className="lg:col-span-5 lg:col-start-8">
            <motion.div whileHover={{ y: -6 }} transition={{ type: "spring", stiffness: 260, damping: 20 }}
              className="relative overflow-hidden rounded-[28px] border border-white/10 bg-card p-8 sm:p-10" data-testid="ceo-card">
              <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-saffron/15 blur-3xl" />
              <p className="eyebrow">{a.leader}</p>
              <div className="mt-8 flex items-center gap-5">
                {s.ceo_photo ? (
                  <img src={s.ceo_photo} alt={name} className="h-20 w-20 shrink-0 rounded-[22px] object-cover" data-testid="ceo-photo" />
                ) : (
                  <span className="flex h-20 w-20 shrink-0 items-center justify-center rounded-[22px] bg-saffron font-display text-3xl font-extrabold text-ink" aria-hidden="true">{initials(name)}</span>
                )}
                <div>
                  <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-testid="ceo-name">{name}</p>
                  <p className="mt-1 text-sm text-orange-300" data-testid="ceo-title">{title}</p>
                </div>
              </div>
              <p className="mt-8 text-sm leading-relaxed text-slate-300">{a.ceoLine}</p>
              {s.phone && (
                <a href={`tel:${s.phone.replace(/[^\d+]/g, "")}`} className="btn-ghost mt-8" data-testid="ceo-call-btn"><Phone size={16} /> {s.phone}</a>
              )}
            </motion.div>
          </Reveal>
        )}
      </div>
    </section>
  );
};
